import { IValidationError } from './interfaces/ValidationError';

interface IParams {
  value: string | undefined,
  fieldName: string,
  fieldCaption: string,
}

const getDefaultMessage = (params: { fieldCaption?: string }) => {
  return `Special symbols are not allowed in ${ params.fieldCaption }`;
};

export const validateSpecialSymbolsExistence = (params: IParams, getMessage = getDefaultMessage): IValidationError => {
  // eslint-disable-next-line no-useless-escape
  if (/[_!¡?÷¿\/\\+=@#$%ˆ^*()№{}"`|~<>,;:[\]]+/.test(params.value!)) {
    return { [params.fieldName]: getMessage({ fieldCaption: params.fieldCaption }) };
  }
  // @ts-ignore
  return null;
};
